var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizReward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1738983396188,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14839,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M888 0H136C96.4 0 64 32.4 64 72v880c0 39.6 32.4 72 72 72h752c39.6 0 72-32.4 72-72V72c0-39.6-32.4-72-72-72zM370.5 463.1c-7.4-6-24.2-13.5-50.1-22.6-23.2-8.1-41.5-16.1-54.6-24.1-13-7.8-23.7-18.9-31.9-33.1-8.2-14.2-12.2-30.8-12.2-49.6 0-24.7 7.4-47.1 21.9-66.8 14.7-19.8 37.5-32 68.9-36.3v-39h42.3v39c47.3 5.7 78 32.4 92 80.3l-58.5 24c-11.4-32.8-28.9-49.3-52.8-49.3-11.9 0-21.5 3.6-28.7 11-7.3 7.4-11 16.2-11 26.7 0 10.7 3.5 18.8 10.5 24.5 7 5.7 21.9 12.7 44.8 21.1 25.1 9.2 44.9 18 59.1 26 14.3 8.2 25.6 19.5 34.3 33.9 8.4 14.4 12.7 31.2 12.7 50.5 0 29.5-8.8 54.2-26.4 73.8-17.6 19.7-43 31.4-76.3 34.9v50.6h-42.3v-50.4c-55.3-5.7-89.7-37.9-102.9-96.5l65.5-17.1c6 36.9 26.1 55.3 60.2 55.3 15.9 0 27.7-3.9 35.2-11.8 7.5-8 11.3-17.4 11.3-28.6 0.3-11.8-3.5-20.6-11-26.4z m397.6 351.4H255.9c-25.7 0-46.5-20.7-46.5-46.5 0-25.7 20.8-46.5 46.5-46.5H768c12.4 0 24.2 4.9 32.9 13.6s13.6 20.6 13.6 32.9c0 25.7-20.7 46.5-46.4 46.5z m0-259.3H578.2c-25.7 0-46.5-20.7-46.5-46.5 0-25.7 20.8-46.5 46.5-46.5h189.9c12.4 0 24.2 4.9 32.9 13.6s13.6 20.6 13.6 32.9c-0.1 25.7-20.8 46.5-46.5 46.5z m0.1-259.3H607.8c-25.6 0-46.4-20.7-46.4-46.5 0-25.7 20.8-46.5 46.4-46.5h160.4c25.6 0 46.4 20.7 46.4 46.5-0.1 25.7-20.8 46.5-46.4 46.5z",
    fill: "#36ab60",
    "p-id": 14840
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizReward);
export default __webpack_public_path__ + "static/media/quiz_reward.15b32a88957497454479d852caf23ce3.svg";
export { ForwardRef as ReactComponent };